module.exports = __webpack_public_path__ + "img/instagram-color-on-black.38678e06.svg";